import axios from 'axios'

// Verze, se kterou se tahle záložka nastartovala (dosadí se při buildu, viz vue.config.js).
const currentBuildId = process.env.VUE_APP_BUILD_ID || ''

// Ve vývoji se kód bere z dev serveru, ale version.json může servírovat ASP.NET
// ze starého dist/ - hlídání by pak hlásilo novou verzi pořád dokola.
const isEnabled = process.env.NODE_ENV === 'production' && !!currentBuildId

// Jak často se ptáme serveru. Záložka otevřená přes noc se tak sama dozví,
// že je venku nová verze, a nabídne načtení.
const CHECK_INTERVAL_MS = 10 * 60 * 1000

const versionUrl = `${process.env.BASE_URL || '/'}version.json`

export const appVersionService = {
    currentBuildId,
    getNewerBuildId,
    watchForNewVersion
}

async function fetchBuildId() {
    let response = await axios.get(versionUrl, {
        params: { t: Date.now() },
        headers: { 'Cache-Control': 'no-cache' }
    })

    return response.data && response.data.buildId
}

/**
 * Vrátí ID verze ležící na serveru, pokud je jiné než to naše, jinak null.
 */
async function getNewerBuildId() {
    if (!isEnabled) {
        return null
    }

    try {
        let buildId = await fetchBuildId()
        return buildId && buildId !== currentBuildId ? buildId : null
    } catch (e) {
        // Výpadek sítě neřešíme, zkusí se to zase za chvíli.
        return null
    }
}

/**
 * Hlídá, jestli na serveru neleží novější verze aplikace.
 * Kontroluje se hned po startu, pak pravidelně a při každém návratu do záložky.
 * Do callbacku posílá ID verze, která leží na serveru.
 * Vrací funkci, kterou se hlídání zastaví.
 */
function watchForNewVersion(onNewVersion) {
    if (!isEnabled) {
        return () => { }
    }

    let stopped = false

    const stop = () => {
        if (stopped) {
            return
        }

        stopped = true
        clearInterval(timer)
        document.removeEventListener('visibilitychange', onVisibilityChange)
        window.removeEventListener('pageshow', onPageShow)
    }

    const check = async () => {
        if (stopped) {
            return
        }

        let buildId = await getNewerBuildId()

        if (buildId) {
            stop()
            onNewVersion(buildId)
        }
    }

    const onVisibilityChange = () => {
        if (document.visibilityState === 'visible') {
            check()
        }
    }

    // Stránka obnovená z bfcache (na iOS běžné) může běžet na starém kódu,
    // aniž by se cokoli stahovalo znovu.
    const onPageShow = (event) => {
        if (event.persisted) {
            check()
        }
    }

    const timer = setInterval(check, CHECK_INTERVAL_MS)
    document.addEventListener('visibilitychange', onVisibilityChange)
    window.addEventListener('pageshow', onPageShow)

    check()

    return stop
}
